/**
 * Scroll Reveal — một IntersectionObserver dùng chung cho mọi hiệu ứng reveal trên site.
 */
var observer = new IntersectionObserver(
  function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.15 }
);

function observeRevealElements() {
  var elements = document.querySelectorAll('.js-reveal:not(.is-visible), .js-showcase-block:not(.is-visible)');
  elements.forEach(function (el) {
    observer.observe(el);
  });
}

observeRevealElements(); // phần tử có sẵn trong HTML

// Chạy lại khi DOM sẵn sàng, để bắt cả phần tử do JS thêm vào.
document.addEventListener('DOMContentLoaded', observeRevealElements);

export { observeRevealElements };
